import { PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE_KEY } from '../wagmi/e2e-consts'

const IS_NOT_PLAYWRIGHT = import.meta.env.VITE_PLAYWRIGHT !== '1'

const PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE = (window as any)[PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE_KEY] === true
export const USDC_ACCOUNT_ENABLED =
  PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE || (IS_NOT_PLAYWRIGHT && import.meta.env.VITE_FEATURE_USDC_ACCOUNT === '1')
